import { assignSafe } from '@summit/core';
export class EPosition {
  longitude: number;
  latitude: number;
  altitude: number;

  constructor(jsonData?: Partial<EPosition>) {
    //Pre clean up
    if (jsonData?.altitude && !isFinite(jsonData?.altitude)) {
      jsonData.altitude = 0;
    }
    //Normal
    assignSafe(this, jsonData);
    // console.log(`Created ${JSON.stringify(this, null, 2)} from ${JSON.stringify(jsonData, null, 2)}`)
  }

  toLatLng(): { lat: number; lng: number } {
    return {
      lat: this.latitude,
      lng: this.longitude
    };
  }

  toShortString(): string {
    return `${this.latitude}, ${this.longitude}`;
  }
}
